export const frontendUserPairInfoAbi = [
  {
    type: "function",
    name: "userInfoPairsStruct",
    inputs: [
      { name: "pairs", type: "address[]", internalType: "address[]" },
      { name: "who", type: "address", internalType: "address" },
    ],
    outputs: [
      { name: "", type: "uint256", internalType: "uint256" },
      {
        name: "",
        type: "tuple[]",
        internalType: "struct Frontend_UserPairInfo.UserPairInfoStruct[]",
        components: [
          { name: "A", type: "address", internalType: "address" },
          { name: "N", type: "uint256[9]", internalType: "uint256[9]" },
        ],
      },
    ],
    stateMutability: "view",
  },
] as const
